import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import App from "./App";
import { SERVER_BASEURL } from "./constants";
import "./index.css";

// Axios setup
if (import.meta.env.DEV) {
  axios.interceptors.request.use(
    (req) => {
      console.log(req);
      return req;
    },
    (err) => {
      console.log(err);
      return Promise.reject(err);
    },
  );
  axios.interceptors.response.use(
    (response) => {
      console.log(response);
      return response;
    },
    (err) => {
      console.log(err);
      console.log("Error message: " + err.message);
      return Promise.reject(err);
    },
  );
}
axios.defaults.baseURL = SERVER_BASEURL;
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
// React.StrictMode is commented out because it mounts the components twice during development
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  // </React.StrictMode>
);
